<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="selectedLoadProfiles"
      :loading="Loading"
      :items-per-page="5"
    >
      <template v-slot:item.isPublished="{ item }">
        <PublishedChip :item="item" />
      </template>

      <template v-slot:item.Download="{ item }">
        <v-icon small @click="downloadCSV(item.csvFile.file, item.title)">
          mdi-arrow-collapse-down
        </v-icon>
      </template>

      <template v-slot:item.Modify="{ item }">
        <v-icon small @click="openNewWindow(item, 'Edit')"> mdi-pencil </v-icon>
      </template>

      <template v-slot:item.Delete="{ item }">
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>

      <template v-slot:item.Duplicate="{ item }">
        <v-icon small @click="Duplicate(item, 'Duplicate')">
          mdi-content-duplicate
        </v-icon>
      </template>

      <template v-slot:item._updated="{ item }">
        <span>{{ formatDate(item._updated) }} </span>
      </template>

      <template v-slot:item.Published="{ item }">
        <!-- <v-progress-circular v-if="!isCompleted"
              indeterminate
              color="primary"
            >
        </v-progress-circular> -->

        <v-icon v-if="!item.Published" small @click="publish(item)"> 
          mdi-publish 
        </v-icon>

        <!-- <v-icon v-if="item.Published" small @click="publish(item)">
          mdi-close
        </v-icon> -->

        <!-- <v-btn
          text
          class="ma-2"
          :loading="!isCompleted"
          small
          fab
          @click="publish(item)"
        >
          <v-icon small> mdi-publish </v-icon>
        </v-btn> -->
      </template>
    </v-data-table>
    <div v-if="showNewConductorWindow">
      <NewEditSubstationProfile
        :visible="showNewConductorWindow"
        @close="closeWindow"
        WindowLable="Edit Substation Profile"
        :substationProfileData="SubstationProfileData"
        :EditMode="true"
        :profileTypeProp="profileType"
      />
    </div>
    <ConfirmationBox
      confirmationTitle="Delete"
      bodyText="Are you sure you want to delete?"
      :visible="ShowDeleteConfirmation"
      @close="deleteConfirm"
    />
  </div>
</template>

<script>
import { bus } from "../main";
import jsPDF from "jspdf";
import NewEditSubstationProfile from "@/components/newEditSubstationProfile.vue";
import { formatDate } from "@/utility/dateTime";
import AdminFeederStore from "@/services/adminfeederstore.js";
import ConfirmationBox from "@/components/deleteConfirmation.vue";
import PublishedChip from "@/components/publishedStatusChip.vue";
import { downloadCSV } from "@/services/csvDownload";

export default {
  name: "AdminFeederProfile",
  props: ["loadProfiles", "projects", "profileType", "Loading"],
  components: {
    NewEditSubstationProfile,
    ConfirmationBox,
    PublishedChip,
  },
  data() {
    return {
      isCompleted: true,
      deleteItemObj: "",
      isConfirmed: false,
      ShowDeleteConfirmation: false,
      showNewConductorWindow: false,
      SubstationProfileData: [],
      responseData: [],
      timeout: 2000,
      color: "",
      errorMsg: "",
      Notification: false,
      showForm: false,
      showEditForm: false,
      formatDate: formatDate,
      downloadCSV: downloadCSV,
      tableHeaders: {
        feeder: [
          {
            text: "Name",
            align: "start",
            sortable: false,
            value: "title",
          },
          {
            text: "Feeder Name",
            align: "start",
            sortable: false,
            value: "feederName",
          },
          {
            text: "Substation Name",
            align: "start",
            sortable: false,
            value: "substationName",
          },
          { text: "Type", value: "feederType" },
          {
            text: "Feeder Length (Km)",
            value: "feederLengthKm",
            align: "center",
          },
          {
            text: "Feeder Voltage (KV)",
            value: "feederVoltageKV",
            align: "center",
          },
          {
            text: "Sanctioned Load (MW)",
            value: "sanctionedLoadMW",
            align: "center",
          },
          { text: "Last Updated", value: "_updated" },
          { text: "Published", value: "isPublished", align: "center" },
          { text: "Edit", value: "Modify", align: "center", sortable: false },
          { text: "Delete", value: "Delete", align: "center", sortable: false },
          {
            text: "Download",
            value: "Download",
            align: "center",
            sortable: false,
          },
          {
            text: "Publish/Unpublish",
            value: "Published",
            align: "center",
            sortable: false,
          },
        ],
        dt: [
          {
            text: "Name",
            align: "start",
            sortable: false,
            value: "title",
          },
          {
            text: "Substation Name",
            align: "start",
            sortable: false,
            value: "substationName",
          },
          {
            text: "DT Name",
            align: "start",
            sortable: false,
            value: "dtName",
          },

          { text: "Type", value: "feederType" },
          { text: "Capacity (KVA)", value: "dtCapacityKVA", align: "center" },
          { text: "Tapping", value: "dtTapping", align: "center" },
          {
            text: "Feeder Length(KM)",
            value: "feederLengthKm",
            align: "center",
          },
          { text: "Power Factor", value: "powerFactor", align: "center" },
          { text: "Primary Voltage", value: "primaryVoltage", align: "center" },
          {
            text: "Secondary Voltage",
            value: "secondaryVoltage",
            align: "center",
          },
          { text: "Last Updated", value: "_updated" },
          { text: "Published", value: "isPublished", align: "center" },
          { text: "Edit", value: "Modify", align: "center", sortable: false },
          { text: "Delete", value: "Delete", align: "center", sortable: false },
          {
            text: "Download",
            value: "Download",
            align: "center",
            sortable: false,
          },
          {
            text: "Publish/Unpublish",
            value: "Published",
            align: "center",
            sortable: false,
          },
        ],
        substation: [
          {
            text: "Name",
            align: "start",
            sortable: false,
            value: "title",
          },
          {
            text: "Feeder Name",
            align: "start",
            sortable: false,
            value: "feederName",
          },
          {
            text: "Substation Name",
            align: "start",
            sortable: false,
            value: "substationName",
          },
          { text: "Type", value: "feederType" },
          {
            text: "Capacity (MVA)",
            value: "totalCapacityMVA",
            align: "center",
          },
          {
            text: "Incoming Feeder Voltage (KV)",
            value: "incomingFeederVoltageKV",
            align: "center",
          },
          {
            text: "Outgoing Feeder Voltage (KV)",
            value: "outgoingFeederVoltageKV",
            align: "center",
          },
          { text: "Power Factor", value: "powerFactor", align: "center" },
          { text: "Last Updated", value: "_updated" },
          { text: "Published", value: "isPublished", align: "center" },
          { text: "Edit", value: "Modify", align: "center", sortable: false },
          { text: "Delete", value: "Delete", align: "center", sortable: false },
          {
            text: "Download",
            value: "Download",
            align: "center",
            sortable: false,
          },
          {
            text: "Publish/Unpublish",
            value: "Published",
            align: "center",
            sortable: false,
          },
        ],
        state_level: [
          {
            text: "Name",
            align: "start",
            sortable: false,
            value: "title",
          },
          { text: "Last Updated", value: "_updated" },
          { text: "Published", value: "isPublished", align: "center" },
          { text: "Edit", value: "Modify", align: "center", sortable: false },
          { text: "Delete", value: "Delete", align: "center", sortable: false },
          {
            text: "Download",
            value: "Download",
            align: "center",
            sortable: false,
          },
          {
            text: "Publish/Unpublish",
            value: "Published",
            align: "center",
            sortable: false,
          },
        ],
      },
    };
  },

  computed: {
    selectedLoadProfiles: function () {
      return this.loadProfiles.filter(
        (p) => p.profileType === this.profileType
      );
    },
    headers: function () {
      return this.tableHeaders[this.profileType]
        ? this.tableHeaders[this.profileType]
        : "";
    },
  },
  created() {
    bus.$on("justAddedProfileRecord", (data) => {
      this.loadProfiles.push(data);
    });
    bus.$on("justEditedProfileRecord", (data) => {
      // const tobeRemoved = this.loadProfiles.filter(
      //   (element) => element._id === data._id
      // );
      // this.loadProfiles.splice(this.loadProfiles.indexOf(tobeRemoved[0]), 1);
      // this.loadProfiles.push(data);

      let idx = -1;
      const newloadProfiles = this.loadProfiles.map((p) => p);
      newloadProfiles.forEach((element, index) => {
        if (element._id === data._id) {
          idx = index;
        }
      });
      if (idx !== -1) {
        newloadProfiles[idx] = { ...data };
        this.loadProfiles = newloadProfiles;
      }
    });
  },
  methods: {
    createPDF(item) {
      let pdfName = item.Title;
      var doc = new jsPDF();
      var temp = [
        "Title:" + item.title,
        "Date :" + item.date,
        "Voltage :" + item.voltage,
        "Status :" + item.status,
        "Published:" + item.published,
      ];

      doc.text(temp, 10, 10);
      doc.save(pdfName + ".pdf");
    },
    openNewWindow(item) {
      this.showNewConductorWindow = true;
      this.SubstationProfileData = item;
    },
    closeWindow(e) {
      this.showNewConductorWindow = false;
      this.responseData = e;
    },
    getColor(Status) {
      if (Status === false) return "red";
      else return "green";
    },
    async publish(item) {
      this.loading = true;
      this.isCompleted = false;
      await AdminFeederStore.methods
        .doPublish(item._id, !item.isPublished)
        .then((res) => {
          item.isPublished = !item.isPublished;
          bus.$emit("publishNotification", item.isPublished, res._status, "");
          this.isCompleted = true;
        });
    },
    deleteItem(item) {
      this.deleteItemObj = item;
      this.ShowDeleteConfirmation = true;
    },

    deleteConfirm(e) {
      this.ShowDeleteConfirmation = false;
      this.isConfirmed = e;
      if (e) {
        this.doDelete(this.deleteItemObj);
      }
    },
    async doDelete(item) {
      await AdminFeederStore.methods.doDelete(item._id).then((res) => {
        const _status = res.status == "204" ? "OK" : "";
        bus.$emit("deleteNotification", _status);
        if (_status === "OK") {
          this.loadProfiles.splice(this.loadProfiles.indexOf(item), 1);
        }
      });
    },
  },
};
</script>